import { render, staticRenderFns } from "./ReactionSelector.vue?vue&type=template&id=afaaa650&scoped=true&"
import script from "./ReactionSelector.vue?vue&type=script&lang=js&"
export * from "./ReactionSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReactionSelector.vue?vue&type=style&index=0&id=afaaa650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaaa650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
